export var PRODUCTS_PER_PAGE = 28;
export var CATCH_SELLER_SLUG = "catch-1";
/** Retail media banner */

export var RETAIL_MEDIA_PRODUCT_INVENTORY_ID = "product_top_banner";
export var RETAIL_MEDIA_SEARCH_INVENTORY_ID = "search_top_banner";